var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons",attrs:{"id":"health-filter"}},_vm._l((_vm.SHIPMENTS_HEALTH),function(label,key){return _c('span',{key:key,staticClass:"button is-small round",class:( _obj = {'is-selected': _vm.target == key}, _obj[key] = true, _obj ),on:{"click":function($event){return _vm.toggleFilter(key)}}},[_c('span',[_vm._v(_vm._s(label))])])
var _obj;}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-859c5bf6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HealthFilter.vue
// module id = null
// module chunks = 